import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { tagNameAsyncValidate } from 'libs/validation';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Button, Loading, ReduxFormHiddenInput, ReduxFormMaterialTextField } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalExamAddTag extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isClicked, examName, onAddTag, onToggleModal, filter } = this.props;

    const isFiltered = Object.keys(filter.toJS()).length > 0 ? true : false;
    const filterTextInner = [];
    !!filter.get('target') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_1', defaultMessage: '대상' })));
    !!filter.get('send') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_2', defaultMessage: '발송' })));
    !!filter.get('sendError') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' })));
    !!filter.get('read') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_3', defaultMessage: '열람' })));
    !!filter.get('download') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' })));
    !!filter.get('infection') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_4', defaultMessage: '감염' })));
    !!filter.get('infectionPc') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_5', defaultMessage: '감염 PC' })));
    !!filter.get('leakFileCount') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_14', defaultMessage: '파일' })));
    !!filter.get('leakCertCount') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_15', defaultMessage: '인증서' })));
    !!filter.get('leakEmailCount') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_16', defaultMessage: '이메일' })));
    !!filter.get('searchAll') &&
      filterTextInner.push(defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' })));
    let examAddTagFilter = filterTextInner.join(', ');
    if (!!filter.get('searchAll')) {
      examAddTagFilter = examAddTagFilter + ': ' + filter.get('searchAll');
    }

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-examAddTag-area', 'common-content')}
        visible
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTagAdd_1', defaultMessage: '태그 만들기' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagAdd_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('brand-button')} disabled={isClicked} onClick={onAddTag}>
              {defineMessages(formatMessage({ id: 'ModalTagAdd_2', defaultMessage: '생 성' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          <div className={cx('message-header')}>
            {defineMessages(
              formatMessage({
                id: 'ModalExamAddTag_1',
                defaultMessage: '현재 훈련의 필터링된 대상자를 태그로 등록합니다.'
              })
            )}
          </div>
          <Message className={cx('template-detail-box')}>
            <div className={cx('template-detail')}>
              <ReduxFormHiddenInput name="examNo" />
              <ReduxFormHiddenInput name="filter" />
              <List bulleted className={cx('template-detail-list')}>
                <List.Item className={cx('template-detail-item')}>
                  <div className={cx('template-detail-item-title')}>
                    {defineMessages(formatMessage({ id: 'ExamListItem_1', defaultMessage: '훈련명' }))}
                  </div>
                  {examName}
                </List.Item>
                {!!isFiltered && (
                  <List.Item className={cx('template-detail-item')}>
                    <div className={cx('template-detail-item-title')}>
                      {defineMessages(formatMessage({ id: 'ExamSearch_18', defaultMessage: '필터' }))}
                    </div>
                    {examAddTagFilter}
                  </List.Item>
                )}
                <List.Item className={cx('template-detail-item', 'item-title-tag')}>
                  <div className={cx('template-detail-item-title')}>
                    {defineMessages(formatMessage({ id: 'ModalTagAdd_4', defaultMessage: '태그명' }))}
                  </div>
                  <ReduxFormMaterialTextField
                    className={cx('no-label', 'input-area')}
                    required={false}
                    validate={['required', 'tagName']}
                    name="tagName"
                    checkType={101}
                  />
                </List.Item>
              </List>
            </div>
          </Message>
        </div>
      </ModalTemplate>
    );
  }
}

ModalExamAddTag.propTypes = {
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      examNo: props.examNo,
      filter: props.filter
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formExamAddTag',
    enableReinitialize: true,
    asyncValidate: tagNameAsyncValidate,
    asyncBlurFields: ['tagName'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(ModalExamAddTag))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalExamAddTag.js